import { useZoneStore } from '../../stores/zone/zone-store';
export default function WidgetZone(props) {
    const store = useZoneStore();
    return store.getZoneComponent(props.name);
}
